import React, { useCallback, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";

import { useIntl } from "react-intl";

// UX
import ReExaminationUX from "./ReExaminationUX";
import ModalItemFilterCustom from "./ModalItemFilterCustom";
import { RowInfo } from "react-table-6";

// type
type ReExaminationProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: Function) => any;
  // data
  reExamEncounterList?: any[];
  openModalFilterReExamDate?: boolean;
  dateFilterListReExam?: any[];
  openModalFilterReExamDentist?: boolean;
  dentistFilterListReExam?: any[];
  openModalFilterReExamClinic?: boolean;
  clinicFilterListReExam?: any[];
};

const ReExamination = (props: ReExaminationProps) => {
  const intl = useIntl();

  useEffect(() => {
    props.onEvent({ message: "HandleResetFilterReExam", params: {} });
  }, []);

  const isActive = useCallback((list: any[] = []) => {
    return list.find((item: any) => item.is_selected === false);
  }, []);

  return (
    <div>
      {props.openModalFilterReExamDate && (
        <ModalItemFilterCustom
          name="Date"
          data={props.dateFilterListReExam}
          onClose={() => props.setProp("openModalFilterReExamDate", false)}
          textField="name"
          style={{ transform: "translate(1vw, 80px)" }}
          onSelect={(list, listArray) =>
            props.onEvent({
              message: "SetReExamDateFilter",
              params: {
                filter: listArray,
              },
            })
          }
        />
      )}
      {props.openModalFilterReExamDentist && (
        <ModalItemFilterCustom
          name={intl.formatMessage({ id: "cukey65" })}
          data={props.dentistFilterListReExam}
          onClose={() => props.setProp("openModalFilterReExamDentist", false)}
          textField="name"
          style={{ transform: "translate(14vw, 80px)" }}
          onSelect={(list, listArray) =>
            props.onEvent({
              message: "SetReExamDentistFilter",
              params: {
                filter: listArray,
              },
            })
          }
        />
      )}
      {props.openModalFilterReExamClinic && (
        <ModalItemFilterCustom
          name={intl.formatMessage({ id: "cukey54" })}
          data={props.clinicFilterListReExam}
          onClose={() => props.setProp("openModalFilterReExamClinic", false)}
          textField="name"
          style={{ transform: "translate(34vw, 80px)" }}
          onSelect={(list, listArray) =>
            props.onEvent({
              message: "SetReExamClinicFilter",
              params: {
                filter: listArray,
              },
            })
          }
        />
      )}

      <ReExaminationUX
        encounterMedical={props.reExamEncounterList} // edit from encounterMedical to encounterList
        columnsReExamination={[
          {
            Header: (
              <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                Date
                <Icon
                  className="re-examination-filter-date"
                  name="filter"
                  style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.dateFilterListReExam) ? "yellow" : "" }}
                  onClick={() => props.setProp("openModalFilterReExamDate", true)}
                />
              </div>
            ),
            width: 120,
            Cell: (row: RowInfo) => {
              return (
                <>
                  {row.original.started}
                  <br />
                  {row.original.encounter_number}
                </>
              );
            },
          },
          {
            Header: (
              <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                {intl.formatMessage({ id: "cukey65" })}
                <Icon
                  className="re-examination-filter-dentist"
                  name="filter"
                  style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.dentistFilterListReExam) ? "yellow" : "" }}
                  onClick={() => props.setProp("openModalFilterReExamDentist", true)}
                />
              </div>
            ),
            accessor: "doctor_name",
            minWidth: 90,
            Cell: (row: RowInfo) => {
              return <>{row.original.doctor_name || row.original.doctor_fullname}</>;
            },
          },
          {
            Header: (
              <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center" }}>
                {intl.formatMessage({ id: "cukey54" })}
                <Icon
                  className="re-examination-filter-clinic"
                  name="filter"
                  style={{ marginLeft: "5px", cursor: "pointer", zIndex: 2, color: isActive(props.clinicFilterListReExam) ? "yellow" : "" }}
                  onClick={() => props.setProp("openModalFilterReExamClinic", true)}
                />
              </div>
            ),
            accessor: "division_name",
            minWidth: 90,
          },
          {
            Header: "",
            width: 150,
            Cell: (row: any = {}) => (
              <div style={{ textAlign: "center" }}>
                {
                  <Button
                    color={"blue"}
                    onClick={(e: any) => {
                      props.setProp("isModalReExaminationLoading", true);

                      props.onEvent({
                        message: "getIdEncounter",
                        params: { id: row.original.encounter, data: row.original },
                      });
                    }}
                  >
                    {intl.formatMessage({ id: "cukey191" })}
                  </Button>
                }
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};

export default React.memo(ReExamination);
